import { put } from "redux-saga/effects";

// import { USER_LOGIN } from "../CONSTANTS";
import * as CLIENTS from "model/subsystems/clients/CONSTANTS";
import { CONSTANTS as ACCESS } from "@lifepay/redux-subsystem-access";

export default function* onUserLogout({ gqlclient }) {
  yield put({ type: CLIENTS.STOP_LISTEN_FOR_CALLS });
  yield put({ type: CLIENTS.CLEAR });
  yield put({ type: ACCESS.CLEAR });
  yield put({ type: CLIENTS.STOP });
  gqlclient.resetStore();
  if (!window.debug) {
    console.clear();
  }
}



// WEBPACK FOOTER //
// ./src/model/subsystems/app/saga/onUserLogout.js